import { authLogout, authSetUser } from '@features/auth/model/actions.js';
import { createReducer } from '@reduxjs/toolkit';
import type { LatLon } from '@shared/types/common.js';
import { saveHomeLocation, setSelectingHomeLocation } from './actions.js';

export interface HomeLocationState {
  homeLocation: LatLon | null;
  selectingHomeLocation: LatLon | null | false;
}

export const homeLocationInitialState: HomeLocationState = {
  homeLocation: null,
  selectingHomeLocation: false,
};

export const homeLocationReducer = createReducer(
  homeLocationInitialState,
  (builder) =>
    builder
      .addCase(authSetUser, (state, action) => {
        if (action.payload?.coordinates) {
          state.homeLocation = action.payload.coordinates;
        }
      })
      .addCase(authLogout, (state) => {
        state.homeLocation = null;
      })
      .addCase(setSelectingHomeLocation, (state, action) => {
        state.selectingHomeLocation =
          action.payload === true ? state.homeLocation : action.payload;
      })
      .addCase(saveHomeLocation, (state, action) => {
        state.homeLocation = action.payload;

        state.selectingHomeLocation = false;
      }),
);
